import { useLazyQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_PREBID_CONFIGURATION } from './api/query'
import {
  UseGetWorkspacePrebidConfiguration,
  UseGetWorkspacePrebidConfigurationParams,
} from './types'

export const useGetWorkspacePrebidConfiguration = ({
  workspaceId,
}: UseGetWorkspacePrebidConfigurationParams): UseGetWorkspacePrebidConfiguration => {
  const [workspacePrebidConfiguration, setWorkspacePrebidConfiguration] =
    useState<WorkspacePrebidConfiguration>()

  const [query] = useLazyQuery(GET_WORKSPACE_PREBID_CONFIGURATION, {
    onCompleted: ({ workspacePrebidConfiguration }) => {
      if (workspacePrebidConfiguration) {
        setWorkspacePrebidConfiguration(fromDTO(workspacePrebidConfiguration))
      }
    },
  })

  useEffect(() => {
    if (workspaceId) {
      query({ variables: { workspaceId } })
    }
  }, [workspaceId])

  return { workspacePrebidConfiguration }
}
